import React, { useState } from 'react';

import api from 'services/api';

import { useDashboard } from 'containers/dashboard';
import searchTextHook from 'helpers/searchTextHook';

import Button from 'components/Button';
import Spinner from 'components/Spinner';
import GridFlex from 'components/GridFlex';
import { SmallSelect, Checkbox } from 'components/Fields';

import { WrapperSelect, WrapperButtonSelect, WrappCheckbox } from '../styles';

const filterType = 'countries';

const CountryFilter: React.FC = () => {
  const {
    data: {
      filters: {
        multiples: { countries },
      },
    },
    actions: { addToFilter, hasOnFilter, removeFilter, resetFilter },
  } = useDashboard();

  const [loading, setLoading] = useState(false);
  const [list, setList] = useState([]);
  const { search, setSearch, setFilteredItems, filteredItems } = searchTextHook(
    {
      items: list,
    },
  );

  const getCountries = async () => {
    setLoading(true);

    try {
      const newList: any = await api.get('/countries');
      setList(newList);
      setFilteredItems(newList);
      setLoading(false);
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <WrapperSelect>
      <SmallSelect
        withInputSearch
        dataTest="select-country"
        inputSearchPlaceholder="Search"
        inputSearchOnChange={setSearch}
        inputSearchvalue={search}
        placeholder="Country"
        numberSelected={Number(countries?.length)}
        maxHeight="270px"
        onOpen={() => !list.length && getCountries()}
        auxiliaryButton={
          <WrapperButtonSelect>
            <Button
              scheme="nobg"
              data-testid="reset-filter"
              onClick={() => {
                setSearch('');
                resetFilter(filterType);
              }}
              padding="9px 20px"
            >
              Reset filters
            </Button>
          </WrapperButtonSelect>
        }
      >
        <>
          {loading ? (
            <GridFlex alignItems="center" justifyContent="center">
              <Spinner />
            </GridFlex>
          ) : (
            <WrappCheckbox>
              {filteredItems?.map(item => (
                <Checkbox
                  key={`${filterType}-${item.id}-${item.description}`}
                  isChecked={hasOnFilter(filterType, item)}
                  label={item.description}
                  name={item.description}
                  onClick={() =>
                    !hasOnFilter(filterType, item)
                      ? addToFilter(filterType, item)
                      : removeFilter(filterType, item)
                  }
                  width="11px"
                  widthIcon="5px"
                  marginRightIcon="7px"
                  textFontSize={11}
                />
              ))}
            </WrappCheckbox>
          )}
        </>
      </SmallSelect>
    </WrapperSelect>
  );
};

export default CountryFilter;
